import axios from "axios"

export function getBoxActivityLog (uuid) {
  return new Promise((resolve, reject) => {
    axios.get(`/distributor/admin/api/v1/inventory/box/stock-activity/${uuid}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  })
}